/* eslint-disable react/jsx-no-target-blank */
import React from 'react'
import {useIntl} from 'react-intl'
import {KTSVG} from '../../../../helpers'
import {SidebarMenuItemWithSub} from './SidebarMenuItemWithSub'
import {SidebarMenuItem} from './SidebarMenuItem'
import { useAuth } from '../../../../../app/modules/auth'

const SidebarMenuMain = () => {
  const intl = useIntl()
  const {auth} = useAuth()

  return (
    <>
     {/*  <SidebarMenuItem
        to='/dashboard'
        icon='/media/icons/duotune/art/art002.svg'
        title={intl.formatMessage({id: 'MENU.DASHBOARD'})}
        fontIcon='bi-app-indicator'
      />
      */}
      {/* <SidebarMenuItem
        to='/builder'
        icon='/media/icons/duotune/general/gen019.svg'
        title='Layout Builder'
        fontIcon='bi-layers'
      /> */}

<SidebarMenuItem
        to='/apps/hotel-management/hotels'
        icon='/media/icons/duotune/general/gen051.svg'
        title={intl.formatMessage({id: 'MENU.HOTELMANAGEMENT'})}

        fontIcon='bi-layers'
      />
  {auth?.role === 'ROLE_SUPER_ADMIN' && (
     
      <SidebarMenuItem
        to='/apps/user-management/users'
        icon='/media/icons/duotune/general/gen051.svg'
        title={intl.formatMessage({id: 'MENU.USERMANAGEMENT'})}
        fontIcon='bi-layers'
      />)}

      <SidebarMenuItem
        to='/apps/reservation-management/reservations'
        icon='/media/icons/duotune/general/gen051.svg'
        title={intl.formatMessage({id: 'MENU.RESERVATIONMANAGEMENT'})}
        fontIcon='bi-layers'
      />
        <SidebarMenuItem
        to='/apps/facilities-management/facilities'
        icon='/media/icons/duotune/general/gen051.svg'
        title={intl.formatMessage({id: 'MENU.FACILITIESMANAGEMENT'})}
        fontIcon='bi-layers'
      />
          <SidebarMenuItem
        to='/apps/themes-management/themes'
        icon='/media/icons/duotune/general/gen051.svg'
        title={intl.formatMessage({id: 'MENU.THEMESMANAGEMENT'})}
        fontIcon='bi-layers'
      />
          <SidebarMenuItem
        to='/apps/options-management/options'
        icon='/media/icons/duotune/general/gen051.svg'
        title={intl.formatMessage({id: 'MENU.OPTIONSMANAGEMENT'})}
        fontIcon='bi-layers'
      />
          <SidebarMenuItem
        to='/apps/booking-extras-management/booking-extras'
        icon='/media/icons/duotune/general/gen051.svg'
        title={intl.formatMessage({id: 'MENU.BOOKINGEXTRASMANAGEMENT'})}
        fontIcon='bi-layers'
      />
          <SidebarMenuItem
        to='/apps/services-management/cms-services'
        icon='/media/icons/duotune/general/gen051.svg'
        title={intl.formatMessage({id: 'MENU.SERVICESMANAGEMENT'})}
        fontIcon='bi-layers'
      />
          <SidebarMenuItem
        to='/apps/agencies-management/agencies'
        icon='/media/icons/duotune/general/gen051.svg'
        title={intl.formatMessage({id: 'MENU.AGENCIESMANAGEMENT'})}
        fontIcon='bi-layers'
      />
          <SidebarMenuItem
        to='/apps/payment-methods-management/payment-methods'
        icon='/media/icons/duotune/general/gen051.svg'
        title={intl.formatMessage({id: 'MENU.PAYMENTMETHODSMANAGEMENT'})}
        fontIcon='bi-layers'
      />
           
          <SidebarMenuItem
            to='/apps/pages-management/pages'
            icon='/media/icons/duotune/general/gen051.svg'
            title={intl.formatMessage({id: 'MENU.PAGESMANAGEMENT'})}
            fontIcon='bi-layers'
          />
      <SidebarMenuItem
        to='/apps/newsletter-management/subscribers'
        icon='/media/icons/duotune/communication/com010.svg'
        title={intl.formatMessage({id: 'MENU.NEWSLETTERMANAGEMENT'})}
        fontIcon='bi-layers'
      />
    {/*  <SidebarMenuItem
        to='/apps/footer-management/footer'
        icon='/media/icons/duotune/general/gen051.svg'
        title={intl.formatMessage({id: 'MENU.FOOTERMANAGEMENT'})}

        fontIcon='bi-layers'
      />
       <SidebarMenuItem
        to='/apps/header-management/header'
        icon='/media/icons/duotune/general/gen051.svg'
        title={intl.formatMessage({id: 'MENU.HEADERMANAGEMENT'})}

        fontIcon='bi-layers'
      />
        <SidebarMenuItemWithSub
        to=''
        icon='/media/icons/duotune/general/gen051.svg'
        title={intl.formatMessage({id: 'MENU.CMS_PAGES'})}
    
      >
        <SidebarMenuItem
          to='/apps/Contact-management/Contact'
          icon='/media/icons/duotune/general/gen051.svg'
          title={intl.formatMessage({id: 'MENU.CONTACT_PAGE'})}
          hasBullet={false}
        />
         <SidebarMenuItem
          to='/apps/aontact-management/about'
          icon='/media/icons/duotune/general/gen051.svg'
          title={intl.formatMessage({id: 'MENU.ABOUT_PAGE'})}
          hasBullet={false}
        />
      </SidebarMenuItemWithSub> 
      */}
    </>
  )
}

export {SidebarMenuMain}
